export const ensurePersistentStorage = async () => {
  if (!navigator.storage?.persist) return null;
  try {
    return (
      (await navigator.storage.persisted()) ||
      (await navigator.storage.persist())
    );
  } catch (error) {
    console.warn('[PersistentStorage] Request failed:', error);
    return null;
  }
};

export const isStoragePersisted = async () => {
  if (!navigator.storage?.persisted) return null;
  try {
    return await navigator.storage.persisted();
  } catch (error) {
    return null;
  }
};
